interface CreateConfirmDataParams {
  isArchived: boolean;
  subjectName: string;
}

interface CreateConfirmDataReturn {
  title: string;
  description: string;
  cancelVariant: 'slab-primary' | 'slab-secondary';
  submitVariant: 'slab-primary' | 'slab-secondary';
  submitButton: string;
}

export const createConfirmData = ({
  isArchived,
  subjectName,
}: CreateConfirmDataParams): CreateConfirmDataReturn => {
  const isArchiving = isArchived !== true;

  const title = isArchiving ? 'Confirm archive' : 'Confirm restore';
  const description = isArchiving
    ? `Are you sure you want to archive this ${subjectName}`
    : `Are you sure you want to restore this ${subjectName}`;

  const cancelVariant = isArchiving ? 'slab-primary' : 'slab-secondary';
  const submitVariant = isArchiving ? 'slab-secondary' : 'slab-primary';

  const submitButton = isArchiving ? 'Archive' : 'Restore';

  return {
    title,
    description,
    cancelVariant,
    submitVariant,
    submitButton,
  };
};
